export const buildingData = [
  {
    building_id: 'co01',
    building_name: 'サークルオー',

    logo: '/assets/logos/logo.svg',
    teacher_suffix: '先生',
    notifyTitle: 'ろう・難聴児オンライン対話コミュニティ「サークルオー」',
    notifyName: 'サークルオー',
    supportManager: '岡松　有香',
  },
  {
    building_id: 'da01',
    building_name: 'デフアカデミー谷町六丁目校',
    logo: '/assets/logos/da-150x150.png',
    teacher_suffix: '',
    notifyTitle: 'デフアカデミー谷町六丁目校',
    notifyName: 'デフアカデミー谷町六丁目校',
    supportManager: '岡松　有香',
  },
  { building_id: 'test', building_name: 'テスト校舎', logo: '/assets/logos/test_logo.png', teacher_suffix: '', notifyTitle: 'テスト校舎', notifyName: 'テスト校舎' },
];

export function getBuildingName(building_id: string) {
  const data = buildingData.find((i) => i.building_id === building_id);
  return data?.building_name ?? '';
}

export function getBuildingNotifyTitle(building_id: string) {
  const data = buildingData.find((i) => i.building_id === building_id);
  return data?.notifyTitle ?? '';
}
export function getBuildingNotifyName(building_id: string) {
  const data = buildingData.find((i) => i.building_id === building_id);
  return data?.notifyName ?? '';
}

export function getTeacherSuffix(building_id: string) {
  const data = buildingData.find((i) => i.building_id === building_id);
  return data?.teacher_suffix ?? '';
}

export function getBuildingLogo(building_id: string) {
  return buildingData.find((data) => data.building_id === building_id)?.logo;
}

export function getCircleOBuilding(): string {
  return 'co01';
}

export function getDa01Building(): string {
  return 'da01';
}

export const buildingOptions = buildingData.map((d) => {
  return { title: d.building_name, value: d.building_id };
});
